module.exports = __webpack_public_path__ + "img/c02_buildingsightofthesun_Normal_ua.a337f66e.webp";